/**
 * @file paddle pilot groupshow
 * @author wanzhongyun
 */

import React from 'react';
import { IPilotGroup } from './../../type';

import './style.less';


const PilotGroupShow: React.FC<IPilotGroup> = props => {

    const { title, cityGroup, schoolGroup } = props;

    return (
        <div className='paddle-pilot-group-show-wrapper'>
            <div id='groupShow' className='paddle-pilot-anchor' />
            <div className='paddle-pilot-group-show-title'>{ title }</div>

            {
                [cityGroup, schoolGroup].map((item, index) => <div className='paddle-pilot-group-classify-wrapper' key={item.title + index}>
                    <div className='paddle-pilot-group-classify-title'>{ item.title }</div>
                    <div className='paddle-pilot-group-card-wrapper'>
                        {
                            item.list.map(ele => <div className='paddle-pilot-group-card' key={ele.name + ele.desc}>
                                <div className='paddle-pilot-group-card-content'>
                                    <img className='paddle-pilot-group-card-avator' src={ele.avator} alt={ele.name} />
                                    <div className='paddle-pilot-group-card-name'>{ ele.name }</div>
                                    <div className='paddle-pilot-group-card-desc'>{ ele.desc }</div>
                                </div>

                                <div className='paddle-pilot-group-card-hover-content'>
                                    <div className='paddle-pilot-group-card-name'>{ ele.name }</div>
                                    <div className='paddle-pilot-group-card-desc'>{ ele.desc }</div>
                                    <a className='paddle-pilot-group-join-link' href={ele.link} target='_blank' rel='noreferrer'>申请加入</a>
                                </div>
                            </div>)
                        }
                    </div>
                </div>)
            }
        </div>
    );
};

export default PilotGroupShow;